import { types, actions } from './requests'
export const GETCOST_TYPES = {
    ...types('GETCOST'),
}
export const GETCOST_ACTIONS = {
    ...actions('GETCOST'),
}
